var map = {
	"./SBTRKT.mp3": 6354,
	"./duduk.mp3": 5805,
	"./elysium.mp3": 6939,
	"./grounded.mp3": 2847,
	"./jethro.mp3": 4635,
	"./meditation.mp3": 5561,
	"./reunion.mp3": 3762,
	"./shine.mp3": 705,
	"./sleuth.mp3": 153,
	"./the-land-of-sun.mp3": 5913,
	"./wanderer.mp3": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5902;